var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.677 21c.19 0 .381-.074.527-.22a.782.782 0 00.008-1.088L8.807 12l7.405-7.692a.781.781 0 00-.008-1.087.74.74 0 00-1.063.008l-7.925 8.232a.781.781 0 000 1.078l7.925 8.231c.147.153.342.23.536.23"
  })));
};
export default SvgBack;